var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-link",class:{ 'active': _vm.is_active, 'exact-active': _vm.is_exact_active, disabled: _vm.disabled }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }